import { Modal } from "antd";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import { PurchaseLicenseItemForm } from "./PurchaseLicenseItemForm";

const PurchaseLicenseItemModal = ({
  open,
  setOpen,
  purchaseId,
  deviceNo,
  editingItem,
  setEditingItem,
  existingItems = [],
  showRenewal = false,
  onSaved,
}) => {
  const handleClose = () => {
    setEditingItem?.(null);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      footer={null}
      width={580}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <PaymentIcon className="text-[18px] text-black" />
          <span className="text-[14px] font-[Poppins] text-black ml-2">
            {editingItem?.ItemNo != null
              ? "Edit License item"
              : "Add License item"}
          </span>
        </div>
      }
    >
      <PurchaseLicenseItemForm
        purchaseId={purchaseId}
        deviceNo={deviceNo}
        editingItem={editingItem}
        existingItems={existingItems}
        showRenewal={showRenewal}
        onCancel={handleClose}
        onSaved={onSaved}
      />
    </Modal>
  );
};

export default PurchaseLicenseItemModal;
